require('./bootstrap');

window.Vue = require('vue').default;

import vuetify from './vuetify';
import App from './App.vue';
import VueAxios from 'vue-axios';
import VueRouter from 'vue-router';
import axios from 'axios';
import { routes } from './routes';
// import '@mdi/font/css/materialdesignicons.css';
import VueSocialauth from 'vue-social-auth';
import i18n from './i18n/i18n';
import { rules } from './rules.js';
import { date } from './dates.js';
import { globalBaseUrl, unduh } from './globalFunction.js';
import { nilai } from './nilai.js';
import { dokumen } from './dokumen.js';

let baseURL = globalBaseUrl;
Vue.prototype.$rules = rules;
Vue.prototype.$dates = date;
Vue.prototype.$baseurl = baseURL;
Vue.prototype.$unduh = unduh;
Vue.prototype.$nilai = nilai;
Vue.prototype.$dokumen = dokumen;
Vue.prototype.$isFTSP = process.env.MIX_FACULTY_LABEL === 'FTSP';
Vue.prototype.$isFTI = process.env.MIX_FACULTY_LABEL === 'FTI';
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(VueSocialauth, {
    providers: {
        google: {
            clientId: process.env.MIX_GOOGLE_CLIENT_ID,
            client_secret: process.env.MIX_GOOGLE_CLIENT_SECRET,
            redirectUri: process.env.MIX_APP_URL + '/auth/google/callback'
        }
    }
});

window.vm = {};
window.app_name = process.env.MIX_APP_NAME;

const router = new VueRouter({
    base: baseURL,
    mode: 'history',
    routes: routes
});

router.beforeEach((to, from, next) => {
    if (localStorage.getItem('isAuth') === 'true') {
        if (to.name !== 'auth') {
            next();
        }
    } else {
        if (to.name === 'auth' || to.name === 'auth-callback') {
            next();
        } else if (from.name !== 'auth') {
                router.push({ name: 'auth', params: {} , query: {type: (process.env.MIX_APP_ENV && process.env.MIX_APP_ENV !== 'production' ? 'password' : '')}})
        }
    }
});
axios.defaults.withCredentials = true;
axios.defaults.baseURL = baseURL;
const app = new Vue({
    el: '#app',
    vuetify,
    router: router,
    i18n,
    render: h => h(App),
});

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        if (vm.appComponent?.showToast) {
            vm.appComponent.showToast('error', error.response.data.message);
        } else {
            console.warn('appComponent or showToast is not available');
        }
        localStorage.setItem('isAuth', false);
        localStorage.setItem('user', '');
        router.push({ name: 'auth', params: {} });
    } else if (error.response.status === 422) {
        vm.appComponent.showToast('warning', 'Bad Request! ' + error.response.data.message);
    } else {
        vm.appComponent.showToast('error', error.response.data.message);
    }
    return Promise.reject(error);
});
